import Inprogress from '../../assets/img/inprogress.jpg';
const InProgress = () => {
    return (
        <div className="container-fluid p-0">
            <div className="position-relative">
                <img src={Inprogress} alt='' className='w-100 vh-100 object-fit-cover' />
                <div className='position-absolute start-0 top-0 pt-5'>
                    <div className='fwlight display-6 m-5 p-5 d-flex '><div class="vr me-4 bg-danger opacity-100" style={{ width: '2px', }}></div> Site in progress</div>
                </div>
            </div>
        </div>
    )
}
export default InProgress;